import { routerReducer } from 'react-router-redux';
import { combineReducers } from 'redux';
import { authReducer } from './auth';
import { lotteriesReducer } from './lotteries';

export default combineReducers({
  auth: authReducer,
  router: routerReducer,
  lotteries: lotteriesReducer,
});



// WEBPACK FOOTER //
// ./src/core/reducers.js